<div class="itinerary-model-content-inner" *ngIf="routeCraftForm">
  <div class="itinerary-model-content">
  
    <div class="d-flex  mb-3 justify-content-between ion-padding-horizontal align-items-center sticky-top" style="background-color: white; border-bottom: 1px solid #cecece;">
      <div class="d-flex ">
        <div class="box-title-container border-0 px-0">
          <div class="">
            <div class="d-flex align-items-center">
              <div class="icon-container">
                <ion-icon name="map"></ion-icon>
              </div>
              <div>
                <p class="title">Route Craft</p>
                <p class="sub-title">Day to Day Planner</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex" *ngIf="radioValue === 'FreeText'">
        <ion-button *ngIf="!hideAiSection" (click)="generateAiRouteAndPatch()" class="filled-blue-btn">Generate With AI</ion-button>
        <ion-button *ngIf="!hideAiSection" (click)="chooseFileForRouteCraft()" class="filled-blue-btn">Upload Doc</ion-button>
        <ion-button class="unfilled-red-btn" (click)="clearAllRouteFormData()">Clear</ion-button>
      </div>

    </div>
    
  
    <form [formGroup]="routeCraftForm" *ngIf="radioValue === 'FreeText'">
      <div class="form-container ion-padding-horizontal">
          <!-- Free text main container start -->
            <div formArrayName="days">
            <div *ngFor="let day of freeTextDays.controls; index as i" [formGroupName]="i" class="free-text-main-container" >
              <div class="row gap-1">
                <div class="col-2 pe-0">
                  <p class="day-title">Day {{i+1}} - {{getDateByTripIndex(i) | date: 'MMM dd, yyyy'}}</p>
                </div>
                <div class="col ps-0">
                  <div class="input-container">
                    <div [ngClass]="{ 'invalid-input': day.get('title')?.invalid && day.get('title')?.touched }">
                      <input type="text" class="input input-text route-title" formControlName="title" placeholder="Title for the day">
                    </div>
                  </div>
                </div>
              </div>
    
              <div class="row gap-1">
                <div class="col-2 pe-0">
                  <div class="input-container" *ngIf="leadId">
                    <label for="" class="label">Activities</label>
                    <!-- TODO: uncomment for V4.1 -->
                    <!-- <div>
                      <app-meal-plan-input [flexColumn]="true" [items]="meals" [selectAllKey]="MEAL_PLAN.ALL_INCLUSION" formControlName="mealPlan"></app-meal-plan-input>
                    </div> -->
                  </div>
                </div>
                <div class="col ps-0">
                  <div class="input-container">
                    <div [ngClass]="{ 'invalid-input': day.get('description')?.invalid && day.get('description')?.touched }">
                      <app-text-formatting-input formControlName="description" [inputHeight]="'md'"></app-text-formatting-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Free text main container End -->
          <div class="row">
            <div class="col">
              <div class="input-container">
                <label for="" class="label">Notes</label>
                <div>
                  <app-text-formatting-input formControlName="sectionNote"></app-text-formatting-input>
                </div>
              </div>
            </div>
          </div> 

          <div class="row">
            <div class="col-12">
              <div class="input-container">
                <label for="" class="label mb-0 align-middle" style="text-transform: none;"><input formControlName="acknowledgement" type="checkbox" name="" id="" class="align-middle"> I acknowledge that the above Route craft information is correct to the best of my knowledge.</label>
                <p class="mb-0"><span class="warning-message" *ngIf="routeCraftForm.get('acknowledgement')?.invalid && routeCraftForm.get('acknowledgement')?.touched">Please check the acknowledgement to proceed</span></p>
              </div>
            </div>
          </div>
        </div>
      </form>      
  
      <div class="dashed-line"></div>
  </div>

  <div class="ion-padding-horizontal justify-content-between itinerary-model-footer">
    <div class="d-flex align-items-center">
      <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
        <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
        Reset
      </ion-button>
    </div>
    
    <div class="d-flex align-items-center">
      <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
        Save
      </ion-button>
      <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
        Save & Next
      </ion-button>
      <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
        <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>
  
</div>

